import React, { useState } from 'react';
import { Check } from 'lucide-react';
import { COLOR_THEMES } from '../../lib/themes';
import { ResumeThumb } from './ResumeThumb';

// Live theme preview: pick a swatch → real template re-renders with that accent.
export const ThemeShowcase = () => {
  const [theme, setTheme] = useState(COLOR_THEMES[4]);
  return (
    <div className="grid items-center gap-10 lg:grid-cols-2" data-testid="theme-showcase">
      <div>
        <div className="grid max-w-md grid-cols-6 gap-3" role="radiogroup" aria-label="Resume colour theme">
          {COLOR_THEMES.map((th) => (
            <button key={th.id} type="button" role="radio" aria-checked={theme.id === th.id} aria-label={th.name} title={th.name} data-testid={`landing-theme-${th.id}`} onClick={() => setTheme(th)}
              className={`flex h-11 w-11 items-center justify-center rounded-full border-2 transition-transform duration-150 hover:scale-105 ${theme.id === th.id ? 'border-primary' : 'border-white shadow-sm ring-1 ring-border'}`} style={{ background: th.color }}>
              {theme.id === th.id && <Check className="h-4 w-4 text-white" aria-hidden="true" />}
            </button>
          ))}
        </div>
        <p className="mt-4 text-sm text-muted-foreground">Selected: <span className="font-semibold text-primary">{theme.name}</span> · 12 professional accents, applied to headings, rules and skill tags.</p>
      </div>
      <div className="mx-auto w-full max-w-md rounded-2xl border border-border bg-[#EEF1F5] p-4">
        <ResumeThumb templateId="professional" accent={theme.color} className="rounded-md shadow-lg ring-1 ring-black/5" maxHeight={380} />
      </div>
    </div>
  );
};
